export default __webpack_public_path__ + "static/media/hht2_direction_timeline_03.74804dbd.jpg";